import { createFileRoute } from "@tanstack/react-router";
import { UserProfile } from "@/features/user-profile/components/UserProfile";

export const Route = createFileRoute("/user-profile/$user-id")({
  component: UserProfile,
});
